export function truncate(str, max, suffix) {
  if (!str) {return '';}
  if (str.length > max) {
    str = str.substring(0, max + 1);
    str = str.substring(0, Math.min(str.length, str.lastIndexOf(' ')));
    str = str + suffix;
  }
  return str;
}

export function capitalize(s) {
  if(typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function camelize(str) {
  return str.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2) => {
    if (p2) return p2.toUpperCase();
    return p1.toLowerCase();
  });
}